import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { AuthGuard } from './guards/auth/auth.guard';
import { NotAuthGuard } from './guards/notAuth/not-auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/login/login.module' ).then(m => m.LoginPageModule),
    canActivate:[NotAuthGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module' ).then(m => m.RegisterPageModule),
    canActivate:[NotAuthGuard]
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate:[AuthGuard]
  },
  { 
    path: 'campaigns', 
    canActivate:[AuthGuard],
    children:[
      {path:'',loadChildren: () => import('./pages/campaigns/campaigns.module').then(m => m.CampaignsPageModule)},
      { path: 'create-campaigns', loadChildren: ()=> import('./pages/create-campaigns/create-campaigns.module').then( m => m.CreateCampaignsPageModule) },
    ] 
  },
  { path: 'my-orders', loadChildren: () => import('./pages/my-orders/my-orders.module').then(m => m.MyOrdersPageModule) },
  { path: 'news', loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule) },
  { path: 'more-new', loadChildren: './pages/more-new/more-new.module#MoreNewPageModule' },
  {path: '**', loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule)},
  { path: 'tab5', loadChildren: './tab5/tab5.module#Tab5PageModule' },
  // { path: 'my-dashboard', canActivate:[AuthGuard], loadChildren: './pages/my-dashboard/my-dashboard.module#MyDashboardPageModule' },
  
  
  
  
  
  
  // { path: 'client-detail/:client', loadChildren: () => import('./pages/client-detail/client-detail.module').then(m => m.ClientDetailPageModule), canActivate:[AuthGuard] },
  // { path: 'product-detail/:product', loadChildren: () => import('./pages/product-detail/product-detail.module').then( m => m.ProductDetailPageModule), canActivate:[AuthGuard]  },

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes,{ preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
